export const styles = {
  container: {
    width: "375px",
    p: 2,
    overflowY: "auto",
  },
  dialogTitle: {
    display: "flex",
    p: 0,
    justifyContent: "flex-end",
  },
  dialogContent: {
    padding: 0,
    flexDirection: "column",
  },
  image: {
    display: "flex",
    justifyContent: "center",
    height: "160px",
  },
  content: {
    mt: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    textAlign: "center",
  },
  icon: {
    height: "28px",
    width: "28px",
  },
  body: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  dialogActions: {
    display: "flex",
    justifyContent: "center",
    px: 4,
    pb: 4,
  },
  closeIcon: {
    color: "icon.secondary",
  },
};
